module.exports = __webpack_public_path__ + "static/media/wp-en-1.2c0ee146.png";